@import (reference) '../../../../../../constants/spacing.module.less';
@import '../../../../../../constants/screen-width-breakpoints.module.less';

.plan-summary-wrapper {
  position: sticky;
  top: @space-24;

  // 43px = height of the tab list/tab bar, so plan summary aligns with grid content below tabs
  &.with-tab-offset {
    margin-top: 43px;
  }
  background: var(--light--background-color--1);
  border: solid 1px var(--default--border-color--12);
  border-radius: 8px;
  padding: @space-16;
  overflow-y: auto;

  @media @desktop {
    top: @space-16;
  }
  @media @tablet, @mobile {
    top: @space-8;
  }
}

.plan-summary-title {
  font-weight: 500;
  margin: @space-0;
}

.compact-line-item {
  border-bottom: none;
  padding-top: @space-8;
  padding-bottom: @space-4;
}

.select-plan-btn {
  font-size: 16px;
  height: 48px;
  width: 100%;
}

.total-price-section {
  padding: @space-16 0;
  justify-content: space-between;
  align-items: center;

  &.with-border-top {
    margin-top: @space-16;
    border-top: 1px solid var(--default--border-color--6);
  }
}

.trial-line-item-descriptor {
  display: flex;
  align-items: center;

  .trial-info-icon-container {
    margin-left: 5px;
    width: 16px;
    height: 16px;
  }
}

.discount-price {
  color: var(--purple-8D30F7);
}

.coupon-discount-price {
  color: var(--blue-1D5AD8);
}

.discounted-line-item {
  display: inline-flex;
  gap: @space-8;
  align-items: center;
}

.original-price {
  text-decoration: line-through;
  color: var(--gray-74818d);
}

.tax-note {
  font-style: italic;
  color: var(--default--text-color--6);
  margin-top: @space-8;
  text-align: center;
}

.downgrade-warning-banner {
  font-size: 12px;
}
